// DataCache.LookUp_PeriodType
export enum PeriodType {
    CUSTOM = -1,
    DAY,
    WEEK,
    MONTH,
    QUARTER,
    ROLLING_30,
    YEAR,
    WEEKS_6,
    ALL,
}
